import { render, staticRenderFns } from "./PStep1.vue?vue&type=template&id=40a76858&scoped=true"
import script from "./PStep1.vue?vue&type=script&lang=js"
export * from "./PStep1.vue?vue&type=script&lang=js"
import style0 from "./PStep1.vue?vue&type=style&index=0&id=40a76858&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a76858",
  null
  
)

export default component.exports